import React from 'react';
import { FormattedMessage } from 'react-intl';

import { TextButton } from '@xingternal/button';
import { IconArrowRight } from '@xingternal/icons';
import { IllustrationSpotCareerAssessment } from '@xingternal/illustrations';

import { useLoginStates } from '@/hooks';

import * as S from './culture-assessment-styles';

const CULTURE_ASSESSMENT_URL =
  '/career-guidance/company-culture-preferences?sc_o=jobs_jobdetail_move_on_culture_assessment';

export const CultureAssessmentCTA: React.VFC = () => {
  const { isLoggedIn } = useLoginStates();

  return isLoggedIn ? (
    <S.Card to={CULTURE_ASSESSMENT_URL}>
      <IllustrationSpotCareerAssessment />
      <S.Content>
        <S.Headline size="large" noMargin>
          <FormattedMessage id="JOBS_DETAIL_COMPANY_CULTURE_ASSESSMENT_CTA_HEADER" />
        </S.Headline>
        <S.Meta noMargin>
          <FormattedMessage id="JOBS_DETAIL_COMPANY_CULTURE_ASSESSMENT_CTA_META" />
        </S.Meta>
        <TextButton to={CULTURE_ASSESSMENT_URL} icon={IconArrowRight} iconAfter>
          <FormattedMessage id="JOBS_DETAIL_COMPANY_CULTURE_ASSESSMENT_CTA_BODY_COPY" />
        </TextButton>
      </S.Content>
    </S.Card>
  ) : null;
};
